import { Component, EventEmitter, Output } from '@angular/core';
import { CartProduct } from '@scalefast/core';
import { AppRemoveProductFromCartTemplateComponent } from './remove-product-from-cart/remove-product-from-cart.component';

@Component({
  selector: 'app-remove-product-from-cart',
  template: `<app-remove-product-from-cart-template
    (closeModalEvent)="closeRemoveProductModal()"
    (cartProductRemovalEvent)="cartProductRemovalConfirmation()"
  />`,
  standalone: true,
  imports: [AppRemoveProductFromCartTemplateComponent],
})
export class AppRemoveProductFromCartComponent {
  @Output() closeRemoveProductModalEvent = new EventEmitter<void>();
  @Output() cartProductRemovalConfirmationEvent = new EventEmitter<CartProduct>();

  cartProductRemovalConfirmation(): void {
    this.cartProductRemovalConfirmationEvent.emit();
  }

  closeRemoveProductModal(): void {
    this.closeRemoveProductModalEvent.emit();
  }
}
